// extracted by mini-css-extract-plugin
export default {"main":"Tab_main__e2LLM","active":"Tab_active__IB0sO"};